import React from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import SplitInfoCardContent from '../SplitInfoCardContent';
import { splitInfoAccordionCardGridItemProps } from '../layout';
import { SplitInfoCardGridItem } from '../styles';
import { SplitInfoCardProps } from '../types';
import { StyledGrid } from './styles';

const SplitInfoAccordionCard: React.FC<SplitInfoCardProps> = ({
  icon,
  heading,
  body,
  phoneNumber,
  phoneNumberAria,
  openingHours,
  ...props
}) => (
  <StyledGrid {...componentProps(props)}>
    <SplitInfoCardGridItem {...splitInfoAccordionCardGridItemProps} focusable>
      <SplitInfoCardContent
        icon={icon}
        heading={heading}
        body={body}
        phoneNumber={phoneNumber}
        phoneNumberAria={phoneNumberAria}
        openingHours={openingHours}
      />
    </SplitInfoCardGridItem>
  </StyledGrid>
);

export default applyComponentTheme(SplitInfoAccordionCard, 'SplitInfoAccordionCard');
